import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'hmt-date-range-dialog',
    templateUrl: './date-range-dialog.component.html',
    styleUrls: ['./date-range-dialog.component.scss'],
    standalone: false
})
export class DateRangeDialogComponent {
  start: Date | null;
  end: Date | null;

  constructor(
    public dialogRef: MatDialogRef<DateRangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { start: Date | null; end: Date | null }
  ) {
    this.start = data.start;
    this.end = data.end;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    this.dialogRef.close({ start: this.start, end: this.end });
  }
}
